module.exports = __webpack_public_path__ + "img/scorched_mansion_small.c4c78de2.png";